import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ 
  selectedCredentials, 
  onClearSelection, 
  onBulkShare, 
  onBulkDownload, 
  onBulkRevoke, 
  onBulkBackup,
  className = '' 
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  if (selectedCredentials?.length === 0) return null;

  const handleBulkAction = async (action) => {
    setIsProcessing(true);
    try {
      await action();
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 z-40 ${className}`}>
      <div className="bg-background border border-border rounded-lg shadow-lg p-4 min-w-[320px]">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <span className="text-primary-foreground text-sm font-medium">
                {selectedCredentials?.length}
              </span>
            </div>
            <span className="text-sm font-medium text-foreground">
              {selectedCredentials?.length} credential{selectedCredentials?.length !== 1 ? 's' : ''} selected
            </span>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClearSelection}
            className="w-8 h-8"
          >
            <Icon name="X" size={16} />
          </Button>
        </div>

        <div className="flex flex-wrap gap-2">
          <Button
            variant="default"
            size="sm"
            onClick={() => handleBulkAction(onBulkShare)}
            disabled={isProcessing}
            iconName="Share"
            iconPosition="left"
          >
            Share
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleBulkAction(onBulkDownload)}
            disabled={isProcessing}
            iconName="Download"
            iconPosition="left"
          >
            Download
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleBulkAction(onBulkBackup)}
            disabled={isProcessing}
            iconName="Archive"
            iconPosition="left"
          >
            Backup
          </Button>
          
          <Button
            variant="destructive"
            size="sm"
            onClick={() => handleBulkAction(onBulkRevoke)}
            disabled={isProcessing}
            iconName="Trash2"
            iconPosition="left"
          >
            Revoke
          </Button>
        </div>

        {isProcessing && (
          <div className="mt-3 flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Loader2" size={16} className="animate-spin" />
            <span>Processing selected credentials...</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkActionsBar;